export default {
  seat: {
    parenthesis: '（{{text}}）',
    header: {
      station: '구매 정보를 입력해주세요',
      seat: '좌석을 선택해주세요',
      start: '{{time}} 출발',
      confirm: '확인',
      seatConfirm: '좌석 확인',
      reserveConfirm: '예약 내용 확인',
      changeConfirm: '예약 변경 내용 확인',
      bookingConfirm: '※결제 및 예약 완료 후 좌석이 확정됩니다.'
    },
    button: {
      back: '돌아가기',
      prev: '이전',
      next: '다음 단계',
      change: '변경'
    },
    confirmCommon: {
      noticeTitle: '좌석 확인',
      notice1: '※예약 완료 또는 변경 수속 완료 후에 정식으로 확보됩니다.',
      notice2: '좌석은 아직 확보되지 않았습니다.',
      outbound: '가는 편',
      inbound: '오는 편',
      seatLine: '{{carNo}}호차-{{seatNo}}',
      departureStation: '{{station}} 출발',
      arrivalStation: '{{station}} 도착'
    },
    confirmChange: {
      instruction: '내용에 문제가 없으면 "변경"을 눌러주세요.',
      contentLabel: '변경 내용',
      before: '변경 전',
      after: '변경 후',
      noChange: '변경 없음'
    },
    confirmReserve: {
      contentLabel: '예약 내용'
    },
    selectSeatType: {
      title: '좌석 선택 방식',
      auto: '자동 배정',
      manual: '수동 선택'
    },
    station: {
      date: '탑승일',
      startStation: '승차역',
      endStation: '하차역',
      selectTip: '{{name}}을 선택해주세요'
    },
    train: {
      header: '열차를 선택해주세요',
      emptySeat: '빈 좌석',
      wheelchairAvailable: '휠체어 공간 이용 가능',
      wheelchairUnavailable: '휠체어 공간 이용 불가',
      noTrains: '구매 가능한 열차가 없습니다. 운행 정보를 확인해 주세요.',
      trainLabel: '{{trainName}}{{trainServiceNo}}호'
    },
    carriage: {
      carriageCar: '{{carNo}}호차',
      directionUpTitle: '↑ 우나즈키 방면',
      directionDownTitle: '↑ 케야키다이라 방면',
      conductor: '차장석'
    },
    wheelchairConfirm: {
      title: '휠체어 전용 공간을 선택하셨습니다.',
      content: '이 공간은 휠체어 이용 고객 전용입니다.',
      notice1: '휠체어 공간 2개당 동행 1명까지 가능합니다.',
      confirmText: '이대로 선택을 진행하시겠습니까?',
      cancel: '취소',
      confirm: '예'
    }
  },
  error: {
    invalidParams:
      '지정하신 조건에 오류가 있습니다. 번거로우시겠지만 처음부터 다시 시도해 주세요',
    invalidDate: '선택할 수 없는 날짜입니다.',
    lineIdInvalid:
      '노선이 선택되지 않았습니다. 번거로우시겠지만 처음부터 다시 시도해 주세요',
    productIdInvalid:
      '선택하신 좌석 유형이 올바르지 않습니다. 번거로우시겠지만 처음부터 다시 시도해 주세요',
    forbidden:
      '이 작업은 허용되지 않습니다. 번거로우시겠지만 처음부터 다시 시도해 주세요',
    seatChangeCountExceeded: '좌석 변경 횟수는 2회로 제한됩니다.',
    notFound:
      '찾으시는 페이지를 찾을 수 없습니다. 번거로우시겠지만 처음부터 다시 시도해 주세요',
    notFoundTitle: '찾으시는 페이지를 찾을 수 없습니다.',
    notFoundDescription: 'URL이 올바른지 확인해 주세요.',
    systemError: '시스템 오류가 발생했습니다. 나중에 다시 시도해 주세요'
  }
};
